import { render } from "./SelectLangage.vue?vue&type=template&id=3c4bbff7&scoped=true&ts=true"
import script from "./SelectLangage.vue?vue&type=script&lang=ts"
export * from "./SelectLangage.vue?vue&type=script&lang=ts"

import "./SelectLangage.vue?vue&type=style&index=0&id=3c4bbff7&scoped=true&lang=css"

import exportComponent from "/workspaces/theokoel.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4bbff7"]])

export default __exports__